<template>
  <div class="row custom-card-group pt-2">
    <div v-if="!breakdownTotals.length" class="row custom-card-group">
      <Loader topServices='true'/>
    </div>
    <div v-if="breakdownTotals.length && breakdownTotals !== 'noData'" class="row" style="padding-right:0px">
      <div v-for="(item, idx) of breakdownTotals" :key="idx" class="col card custom-card">
        <div class="card-body custom-card-body">
          <p class="card-text" @load="makeCountTrue">{{ item.name }}</p>
          <h5 class="card-title custom-card-title">{{ item.count }}</h5>
        </div>
      </div>
    </div>
    <div v-if="breakdownTotals === 'noData'" class="row custom-card-group">
      <Loader topServicesEmpty='true'/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { dashboardStore } from '@/stores/dashboard'
import Loader from '@/components/utilities/elements/Loader.vue'
export default {
  name: 'ServiceSummary',
  components: {
    Loader
  },
  computed: {
    ...mapState(dashboardStore, ['breakdownTotals'])
  }
}
</script>
<style lang="scss" scoped>
.service-cards {
  background: var(--cs-header-light);
  border: 0px;
  border-radius: 10px;
}
.service-cards p,
.service-cards h4 {
  color: var(--cs-primary);
}
@media (max-width: 767px) {
  .service-cards-container {
    border-bottom: 1px solid var(--border-color);
  }
}
</style>
